import posthog from "posthog-js";
import { beforeSend } from "@/tracking/posthog/before-send";
import { setSiteForFlags } from "@/tracking/posthog/config";

const projectToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;
const host = process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (!projectToken) {
  if (process.env.NODE_ENV === "development") {
    throw new Error(
      "NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN is configured",
    );
  }
} else if (!host) {
  if (process.env.NODE_ENV === "development") {
    throw new Error(
      "NEXT_PUBLIC_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once NEXT_PUBLIC_POSTHOG_HOST is configured",
    );
  }
} else {
  posthog.init(projectToken, {
    api_host: host,
    defaults: "2026-01-30",
    capture_exceptions: true,
    before_send: beforeSend,
    debug: process.env.NODE_ENV === "development",
    // Nothing is written to browser storage until Cookiebot "statistics"
    // consent is granted (production only, since Cookiebot is loaded through
    // GTM). See tracking/posthog/PostHogConsentSync.
    opt_out_capturing_by_default: true,
    opt_out_persistence_by_default: true,
    // Until then, and after a decline, visitors are counted anonymously
    // through a server-side hash instead of cookies. Requires cookieless
    // tracking to be enabled in the PostHog project settings.
    cookieless_mode: "on_reject",
    loaded: setSiteForFlags,
  });
}
